import cx from 'classnames'
import PropertyIcon from 'common/PropertyItem/PropertyIcon'
import Styles from './PropertyActions.module.scss'
import { Property } from 'api/clients/PropertyClient'

interface Props {
  property: Property
  showIcon?: boolean
  active?: boolean
  onMouseEnter?: () => void
  onClick?: () => void
  activeOnHover?: boolean
  className?: string
}

const ExistingPropertyActionItem = ({
  property,
  showIcon = true,
  active = false,
  onMouseEnter,
  onClick,
  activeOnHover,
  className,
}: Props) => {
  return (
    <div
      key={`property-${property.id}`}
      className={cx(
        Styles.resultRow,
        {
          [Styles.active]: active,
          [Styles.activeOnHover]: activeOnHover,
        },
        className,
      )}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
    >
      {showIcon && <PropertyIcon type={property.type} defaultType={property.default_type} />}
      <span className={Styles.resultRowTitle}>{property.name}</span>
    </div>
  )
}

export default ExistingPropertyActionItem
export { ExistingPropertyActionItem }
